import { useEffect, useState } from "react";
import httpService from "../../services/httpService";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

const InsightImagePreview = ({ promptText }) => {
    const [clubs, setClubs]             = useState([]);
    const [episodes, setEpisodes]       = useState([]);
    const [keyTakeaways, setKeyTakeaways] = useState([]);

    const [clubGuid, setClubGuid]     = useState('');
    const [episodeGuid, setEpisodeGuid] = useState('');
    const [ktGuid, setKtGuid]         = useState('');

    const [generating, setGenerating] = useState(false);
    const [image, setImage]           = useState(null);

    useEffect(() => {
        httpService.get('/admin/insight-preview/clubs')
            .then(res => setClubs(res.data.data ?? []))
            .catch(() => {});
    }, []);

    useEffect(() => {
        setEpisodeGuid('');
        setKtGuid('');
        setEpisodes([]);
        setKeyTakeaways([]);
        setImage(null);
        if (!clubGuid) return;
        httpService.get(`/admin/insight-preview/clubs/${clubGuid}/episodes`)
            .then(res => setEpisodes(res.data.data ?? []))
            .catch(() => {});
    }, [clubGuid]);

    useEffect(() => {
        setKtGuid('');
        setKeyTakeaways([]);
        setImage(null);
        if (!clubGuid || !episodeGuid) return;
        httpService.get(`/admin/insight-preview/clubs/${clubGuid}/episodes/${episodeGuid}/key-takeaways`)
            .then(res => setKeyTakeaways(res.data.data ?? []))
            .catch(() => {});
    }, [clubGuid, episodeGuid]);

    const handleGenerate = () => {
        setGenerating(true);
        setImage(null);
        httpService.post('/admin/insight-preview/generate', { prompt: promptText, key_takeaway_guid: ktGuid })
            .then(res => setImage(res.data.data.image))
            .catch(() => {})
            .finally(() => setGenerating(false));
    };

    return (
        <div className="mt-3">
            <hr />
            <small className="text-muted d-block mb-2">
                Preview tool — generates a test image using the prompt text above, including any
                unsaved edits. Nothing here is saved; use it to check how a prompt change would
                render before clicking Save.
            </small>

            <Row className="g-2 mb-2">
                <Col md={4}>
                    <Form.Select size="sm" value={clubGuid} onChange={e => setClubGuid(e.target.value)}>
                        <option value="">Select club…</option>
                        {clubs.map(c => <option key={c.guid} value={c.guid}>{c.title}</option>)}
                    </Form.Select>
                </Col>
                <Col md={4}>
                    <Form.Select size="sm" value={episodeGuid} disabled={!clubGuid} onChange={e => setEpisodeGuid(e.target.value)}>
                        <option value="">Select episode…</option>
                        {episodes.map(e => <option key={e.guid} value={e.guid}>{e.title}</option>)}
                    </Form.Select>
                </Col>
                <Col md={4}>
                    <Form.Select size="sm" value={ktGuid} disabled={!episodeGuid} onChange={e => setKtGuid(e.target.value)}>
                        <option value="">Select insight…</option>
                        {keyTakeaways.map(k => <option key={k.guid} value={k.guid}>{k.title}</option>)}
                    </Form.Select>
                </Col>
            </Row>

            <Button size="sm" variant="outline-primary" disabled={!ktGuid || generating} onClick={handleGenerate}>
                {generating ? <><Spinner size="sm" animation="border" className="me-2" />Generating…</> : 'Generate Preview'}
            </Button>

            {image && (
                <img
                    src={`data:image/jpeg;base64,${image}`}
                    className="img-fluid rounded w-100 mt-3"
                    alt="Generated preview"
                />
            )}
        </div>
    );
};

export default InsightImagePreview;
